<template>
  <nav class="isolate inline-flex -space-x-px bg-white">
    <div
      v-for="(link, i) in pagination.links"
      :key="`link-${i}`"
    >
      <Link
        v-if="link.label === '&laquo; Vorige'"
        :href="link.url"
        class="relative h-full inline-flex items-center rounded-l px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-500 hover:bg-gray-100 focus:z-20 focus:outline-offset-0"
      >
        <span class="sr-only">Previous</span>
        <i class="fa fa-chevron-left w-5 !font-normal text-center text-sm" />
      </Link>
      <Link
        v-else-if="link.label === 'Volgende &raquo;'"
        :href="link.url"
        class="relative h-full inline-flex items-center rounded-r px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-500 hover:bg-gray-100 focus:z-20 focus:outline-offset-0"
      >
        <span class="sr-only">Next</span>
        <i class="fa fa-chevron-right w-5 !font-normal text-center text-sm" />
      </Link>
      <Link
        v-else
        :href="link.url"
        aria-current="page"
        class="relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-500 focus:z-20 focus:outline-offset-0"
        :class="{
          'bg-sky-500 hover:bg-sky-600 text-white': link.active,
          'bg-white hover:bg-gray-100 text-gray-900': !link.active
        }"
      >
        {{ link.label }}
      </link>
    </div>
  </nav>
</template>

<script>
import {Link} from '@inertiajs/vue2';

export default {
  components: {
    Link,
  },

  props: {
    pagination: {
      required: true,
      type: Object,
    },
  },
};
</script>
